import React, { FC } from 'react'
import copy from 'copy-to-clipboard'

import { CardDropdown, Dropdown } from '@sketch/components'
import { useToast } from '@sketch/toasts'

export interface PrototypeCardDropdownProps {
  pathname: string
}

const PrototypeCardDropdown: FC<PrototypeCardDropdownProps> = ({
  pathname,
}) => {
  const { showToast } = useToast()

  const copyLink = (
    withHotspots: boolean,
    event: React.SyntheticEvent<Element, Event>
  ) => {
    event.preventDefault()

    const queryString = getQueryString(withHotspots)

    const link = `${window.location.origin}${pathname}${queryString}`
    copy(link)
    showToast('Link to Prototype copied', 'positive')
  }

  return (
    <CardDropdown placement="bottom-start" usePortal>
      <Dropdown.Item onClick={event => copyLink(true, event)}>
        Copy link to Prototype with Hotspots
      </Dropdown.Item>
      <Dropdown.Item onClick={event => copyLink(false, event)}>
        Copy link to Prototype with Hotspots disabled
      </Dropdown.Item>
    </CardDropdown>
  )
}

function getQueryString(withHotspots: boolean) {
  const params = []

  if (!withHotspots) {
    params.push('hotspots=false')
  }

  return params.length ? `?${params.join('&')}` : ''
}

export default PrototypeCardDropdown
